import * as Styled from './styled'
import { Props } from './types'

function Modal({
  title,
  content,
  buttonLabel,
  confirmButtonLoading,
  open,
  buttonCancelLabel,
  onConfirm,
  onCancel,
  onClose,
  innerRef
}: Props) {
  return (
    open && (
      <Styled.Background>
        <Styled.Container role="region" ref={innerRef}>
          <Styled.Header>
            <Styled.Title>{title}</Styled.Title>
            <Styled.CloseIcon onClick={onClose} />
          </Styled.Header>
          <Styled.Content>{content}</Styled.Content>
          <Styled.Footer>
            {onCancel && <Styled.CancelButton type="button" onClick={onCancel}>{buttonCancelLabel}</Styled.CancelButton>}
            <Styled.ConfirmButton onClick={onConfirm} fullWidth={!onCancel} isLoading={confirmButtonLoading}>
              {buttonLabel}
            </Styled.ConfirmButton>
          </Styled.Footer>
        </Styled.Container>
      </Styled.Background>
    )
  )
}

export default Modal
